import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'fleetoperate-driver-education',
  templateUrl: './driver-education.component.html',
  styleUrls: ['./driver-education.component.scss']
})
export class DriverEducationComponent implements OnInit {

  @Input() group: FormGroup;
  
  constructor() { }

  ngOnInit() {
  }

}
